import { ILanguage } from "../interfaces";
import Axios from "../utils/axios";
import { getCurrentTimestamp } from "../utils/functions";

const axios = new Axios();

export const getLanguages = async () => {
  const languages = await axios.Get("language");

  return languages.data.map((language: ILanguage) => ({
    id: language.id,
    name: language.name,
    abbreviation: language.abbreviation ?? "",
    _ts: language._ts,
  }));
};

export const createLanguage = async (payload: {
  name: string;
  abbreviation: string;
}): Promise<ILanguage> => {
  const response = await axios.Post("/Language", {
    name: payload.name,
    abbreviation: payload.abbreviation,
    createdDate: getCurrentTimestamp(),
  });
  const data = response.data as {
    id?: string;
    name?: string;
    abbreviation?: string;
    _ts?: number;
    error?: boolean;
  };
  if (data?.error) {
    throw new Error(
      "This value is already registered in the DB. Please input a different/new one."
    );
  }
  return {
    id: data.id,
    name: data.name ?? payload.name,
    abbreviation: data.abbreviation ?? payload.abbreviation,
    _ts: data._ts,
  };
};